import {mapActions} from "vuex";

export default {
    data(){
        return {
            isShowFiltersBlock: false,
            isShowMobileSearch: false,
            showAdvancedFiltersBlock: (this.$md.mobile() !== null ? true : false),
            table_search_phrase: null
        }
    },
    mounted: function(){

    },
    methods: {
        getFilterData: function(field){
            return this.$store.getters[this.namespace + '/getFilterValueByFilterName'](field);
        },
        setFilters: function(filters){
            this.$store.dispatch(this.namespace + '/setFilters', filters);
        },
        setAdvancedFilter: function(advancedFilters){
            this.$store.dispatch(this.namespace + '/setAdvancedFilters', advancedFilters);
        },
        updateFilter: function(field, value){
            this.$store.dispatch(this.namespace + '/updateFilter', {field: field, value: value});
        },
        updateAdvancedFilter: function(field, value){
            this.$store.dispatch(this.namespace + '/updateAdvancedFilter', {field: field, value: value});
        },
        changeFilter: function(field, value){
            this.updateFilter(field, value);
            this.setUpdatingStatus(true);
            this.startLoading();
            this.setChartUpdatingStatus(true);
        },
        changeFilterWithoutLoading: function(field, value){
            this.updateFilter(field, value);
        },
        changeAdvancedFilter: function(field, value, obj){
            this.updateAdvancedFilter(field, value);
            
            if (this.advancedFilters && this.advancedFilters[field] !== undefined)
            {
                this.advancedFilters[field] = value;
            }

            this.setUpdatingStatus(true);
            this.startLoading();
            this.setChartUpdatingStatus(true);
        },

        ...mapActions({
            setReportColumns(dispatch, payload){
                return dispatch(this.namespace + '/setReportColumns', payload);
            },
            clearPagination(dispatch, payload){
                return dispatch(this.namespace + '/clearPagination', payload);
            },
            setUpdatingStatus(dispatch, payload){
                return dispatch(this.namespace + '/setUpdatingStatus', payload);
            },
            startLoading(dispatch){
                return dispatch(this.namespace + '/startLoading');
            },
            finishLoading(dispatch){
                return dispatch(this.namespace + '/finishLoading');
            },
            setChartUpdatingStatus(dispatch, payload){
                return dispatch(this.namespace + '/setChartUpdatingStatus', payload);
            },
            setReportSearch(dispatch, payload){
                return dispatch(this.namespace + '/setReportSearch', payload);
            }
        }),
        getSitesList(){
            return this.$store.getters.getSitesList;
        },
        getSourcesList(){
            return this.$store.getters.getSourcesList;
        },
        getPartnersList(){
            return this.$store.getters.getPartnersList;
        },
        getAllPartnersList(){
            return this.$store.getters.getAllPartnersList;
        },
        getMarketsList(){
            return this.$store.getters.getMarketsList;
        },
        getDevicesList(){
            return this.$store.getters.getDevicesList;
        },
        applyFilters(){
            if (this.checkFilters())
            {
                this.setAdvancedFilter(this.advancedFilters);
                this.clearPagination();
                this.setUpdatingStatus(true);
                this.startLoading();
                this.setChartUpdatingStatus(true);
                this.showFiltersBlock();
            }
        },
        clearFilters(){
            this.isShowFiltersBlock = false;
        },
        showFiltersBlock(){
            this.isShowFiltersBlock = !this.isShowFiltersBlock;
        },
        closeFiltersBlock(){
            this.isShowFiltersBlock = false;
        },
        setDateRanges(startDate, endDate, startDateB, endDateB, excludedDates, excludedDatesB) {
            this.clearPagination();
            this.setUpdatingStatus(true);
            this.startLoading();
            this.setChartUpdatingStatus(true);

            this.$store.dispatch(this.namespace + '/updateFilter', {field: 'dateRange', value: {startDate: startDate, endDate: endDate, startDateB: startDateB, endDateB: endDateB, excludedDates: excludedDates, excludedDatesB: excludedDatesB}});
        },
        toggleAdvancedFiltersBlock(){
            this.showAdvancedFiltersBlock = !this.showAdvancedFiltersBlock;
        },
        setAutoBiddingDeviceGroup(value){

        },
        setGroupByOption(status){
            let columnsList = this.$store.getters[this.namespace + '/getReportColumns'];

            let dateFieldIndex = columnsList.findIndex(item => item.field == 'date');
            if (dateFieldIndex !== -1)
            {
                columnsList[dateFieldIndex].visible = status;
                columnsList[dateFieldIndex].checked = status;
            }

            this.setReportColumns(columnsList);

            if (this.advancedFilters['groupByDate'] !== undefined)
            {
                this.advancedFilters['groupByDate'] = status;
                this.$store.dispatch(this.namespace + '/updateAdvancedFilters', {field: 'advancedFilters', value: this.advancedFilters});
            }
        },
        setReportView(status){

        },
        setClicksCondition(status){

        },
        toggleMobileSearch(){
            this.isShowMobileSearch = !this.isShowMobileSearch;

            if (this.isShowMobileSearch === false){
                this.table_search_phrase = null;
            }
        },
        useSearch(){
            this.setReportSearch(this.table_search_phrase);
            this.setUpdatingStatus(true);
            this.startLoading();
        },
        removeAdvancedFilters: function(field, value){
            this.updateAdvancedFilter(field, value);
            this.removeParamFromUrl(field);
        },
        initNotification: function() {
            this.$notification.setPosition('topRight')
                .setCloseStatus(true)
                .setCloseOnClick(true)
                .setCloseOnEscape(true)
                .setTimeout(false)
                .setSettings();
        },
        isShowExistedFilters: function(){
            let filtersList = this.$store.getters[this.namespace + '/getFilters'];
            let filters = filtersList.filters;

            return (
                (filters.siteId && filters.siteId.length) || (filters.sourceId && filters.sourceId.length) ||
                (filters.partnerId && filters.partnerId.length) ||
                (filters.marketId && filters.marketId.length) || (filters.deviceId && filters.deviceId.length)
            );
        },
        isDatesComparisonEnabled: function(){

            let isDatesComparisonEnabled = this.$store.getters[this.namespace + '/isDatesComparisonEnabled'];

            if (isDatesComparisonEnabled && this.advancedFilters['groupByDate'] === true)
            {
                this.setGroupByOption(false);
            }

            return isDatesComparisonEnabled;
        },
    }
}



// WEBPACK FOOTER //
// ./src/components/mixins/baseReportFiltersMixin.js